import { useQuery, queryOptions } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { apiClient } from '@cast/infrastructure-api';
import { EvictorAdvancedConfig } from '@cast/types-workload-eviction';

const EVICTOR_ADVANCED_CONFIG_QUERY_KEY = 'workload-eviction-advanced-config';

export const getEvictorAdvancedConfigQueryKey = (params: Params) => {
  return [EVICTOR_ADVANCED_CONFIG_QUERY_KEY, params];
};

type Params = {
  clusterId: string;
};

type UseEvictorAdvancedConfigQueryArgs = {
  params: Params;
  options?: QueryOptions<EvictorAdvancedConfig>;
};

export const getEvictorAdvancedConfigQueryOptions = ({
  params,
  options,
}: UseEvictorAdvancedConfigQueryArgs) =>
  queryOptions({
    queryKey: getEvictorAdvancedConfigQueryKey(params),
    queryFn: async () => {
      const { data } = await apiClient.workloadEviction.getAdvancedConfig(
        params
      );
      return data;
    },
    ...options,
  });

export const useEvictorAdvancedConfigQuery = ({
  params,
  options,
}: UseEvictorAdvancedConfigQueryArgs) => {
  return useQuery(getEvictorAdvancedConfigQueryOptions({ params, options }));
};
